import React from 'react';
import { useTranslation } from 'react-i18next';

/**
 * Горизонтальный логотип (три полосы роста).
 * @param {'dark'|'light'} variant — dark: на красном фоне; light: на белом/сером
 */
export default function Logo({ variant = 'dark', height = 38, className = '', style = {}, alt }) {
    const { t } = useTranslation('common');
    const altText = alt ?? t('common:brandName');
    const src = variant === 'light'
        ? `${process.env.PUBLIC_URL || ''}/logo-horizontal-light.svg`
        : `${process.env.PUBLIC_URL || ''}/logo-horizontal-dark.svg`;

    return (
        <img
            src={src}
            alt={altText}
            className={className}
            style={{ height, width: 'auto', display: 'block', ...style }}
        />
    );
}
